import c from "./constants";

const FilterHelper = (() => {

    const filterType = { FREE_TEXT: 1, DROP_DOWN: 2, DATE_PICKER: 3 };


    const globalUsersFilterOptions = [
        {
            type: c.globalUsersFilterTypes.ALL_USERS,
            label: "All Users",
            isActive: true,
        },
        {
            type: c.globalUsersFilterTypes.PAYG_USERS,
            label: "PAYG Customers",
            isActive: false,
        },
        {
            type: c.globalUsersFilterTypes.NSW_CUSTOMERS,
            label: "NSW Customers",
            isActive: false,
        },
        {
            type: c.globalUsersFilterTypes.VIC_CUSTOMERS,
            label: "VIC Customers",
            isActive: false,
        }
    ]

    const globalBusinessesFilterOptions = [
        {
            type: c.globalBusinessesFilterTypes.ALL_BUSINESSS,
            label: "All Businesses",
            isActive: true,
        },
        {
            type: c.globalBusinessesFilterTypes.NSW_BUSINESSES,
            label: "Targeted NSW",
            isActive: false,
        },
        {
            type: c.globalBusinessesFilterTypes.VIC_BUSINESSES,
            label: "Targeted VIC",
            isActive: false,
        },
    ];

    const globalProfilesFilterOptions = [
        {
            type: c.globalProfilesFilterTypes.ALL_PROFILES,
            label: "All Profiles",
            isActive: false,
        },
    ]

    const globalJobsFilterOptions = [
        {
            type: c.globalJobsFilterTypes.ALL_JOBS,
            label: "All Jobs",
            isActive: true,
        },
        {
            type: c.globalJobsFilterTypes.JOBS_POSTED_TODAY,
            label: "Jobs Posted Today",
            isActive: false,
        },
        {
            type: c.globalJobsFilterTypes.JOBS_EXPIRE_TODAY,
            label: "Jobs Expire Today",
            isActive: false,
        },
        {
            type: c.globalJobsFilterTypes.RECURRING_JOB_POSTED_15_DAYS_AGO,
            label: "Recurring Jobs Posted 15 Days Ago",
            isActive: false,
        },
    ]

    const globalJobRequestsFilterOptions = [
        {
            type: c.globalJobRequestsFilterTypes.ALL_JOB_REQUESTS,
            label: "All Concierge Requests",
            isActive: true,
        },

    ]

    const globalAffiliatesFilterOptions = [
        {
            type: c.globalAffiliatesFilterTypes.ALL_AFFILIATES,
            label: "All Partnerships",
            isActive: true,
        },
        {
            type: c.globalAffiliatesFilterTypes.EMPLOYEE_BENEFITS,
            label: "Employee Benefits",
            isActive: false,
        },
        {
            type: c.globalAffiliatesFilterTypes.REFERRALS,
            label: "Referrals",
            isActive: false,
        },
    ]

    const globalVouchesFilterOptions = [
        {
            type: c.globalVouchesFilterTypes.ALL_VOUCHES,
            label: "All Vouches",
            isActive: true,
        },
    ]

    const globalBotManagerFilterOptions = [
        {
            type: c.globalBotManagerFilterTypes.ALL_BOT_FLOWS,
            label: "All Flows",
            isActive: true,
        },
    ]

    const globalBotSessionsFilterOptions = [
        {
            type: c.globalBotSessionsFilterTypes.ALL_BOT_SESSIONS,
            label: "All Sessions",
            isActive: true,
        },
    ]

    const globalCertificatesFilterOptions = [
        {
            type: c.globalCertificatesFilterTypes.ALL_CERTIFICATES,
            label: "All Certificates",
            isActive: true,
        },
        {
            type: c.globalCertificatesFilterTypes.PENDING_VERIFICATION,
            label: "Pending Verification",
            isActive: false,
        },
    ]

    const globalChecksFilterOptions = [
        {
            type: c.globalChecksFilterTypes.ALL_CHECKS,
            label: "All Checks",
            isActive: true,
        },
    ]

    const profilesFilterOptions = [
        {
            field: "userId",
            label: "USER ID",
            icon: "fa-tag",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "fullName",
            label: "NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "entityTypeName",
            label: "ACCOUNT TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "Family", label: "Family" },
                2: { value: "Business", label: "Business" },
                3: { value: "Helper", label: "Helper" },
            }
        },
        {
            field: "accountStatusName",
            label: "ACCOUNT STATUS",
            icon: "fa-clock-o",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "Pending", label: "Pending" },
                2: { value: "Approved", label: "Approved" },
            }
        },
        {
            field: "requiredReviews",
            label: "REVIEW TYPE",
            icon: "fa-bookmark",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "1", label: "New Profile" },
                2: { value: "32", label: "Missing About Me" },
                3: { value: "2", label: "Missing Au Pair Details" },
                4: { value: "4", label: "Missing Tuturing Details" },
                5: { value: "16", label: "Missing Certificate" },
                6: { value: "8", label: "Tutoring Category Changed" },
            }
        },
        {
            field: "isHidden",
            label: "VISIBILITY",
            icon: "fa-eye",
            isActive: false,
            value: "",
            filterItemSelected: 1,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "false", label: "Visible" },
                2: { value: "true", label: "Hidden" },
            }
        },
    ]

    const businessesFilterOptions = [
        {
            field: "locationId",
            label: "LEAD ID",
            icon: "fa-tag",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "name",
            label: "NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "locationType",
            label: "BUSINESS TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.locationType.SCHOOL, label: "School" },
                2: { value: c.locationType.CENTRE_BASED_DAYCARE, label: "Centre Day Care" },
                3: { value: c.locationType.FAMILY_DAYCARE, label: "Family Day Care" },
                4: { value: c.locationType.INHOME_CARE, label: "In-Home Care" },
                5: { value: c.locationType.OUTSIDE_SCHOOL_HOURS_CARE, label: "OOSH" },
            }
        },
        {
            field: "locationStatus",
            label: "LEAD STATUS",
            icon: "fa-bookmark",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.locationStatus.NEW_LEAD, label: "New Lead" },
                2: { value: c.locationStatus.EDM_SENT, label: "EDM Sent" },
                // 3: { value: c.locationStatus.EDM_READY, label: "EDM Ready" },
                4: { value: c.locationStatus.EDM_OPENED, label: "EDM Opened" },
                5: { value: c.locationStatus.EDM_CLICKED, label: "EDM Clicked" },
                6: { value: c.locationStatus.EDM_REJECTED, label: "EDM Rejected" },
                7: { value: c.locationStatus.CALLS_COMMENCED, label: "Calls Commenced" },
                8: { value: c.locationStatus.CONTACT_MADE, label: "Contact Made" },
                9: { value: c.locationStatus.NOT_INTERESTED, label: "Not Interested" },
                10: { value: c.locationStatus.INTERESTED_IN_PROGRESS, label: "Interested In-Progress" },
                11: { value: c.locationStatus.ACQUIRED, label: "Acquired" },
            }
        },
        {
            field: "helpersCount",
            label: "HELPERS COUNT",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "less than", operator: "lt" },
                3: { value: 3, label: "greater than", operator: "gt" },
            }
        },
        {
            field: "state",
            label: "STATE",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'NSW', value: 'nsw'},
                2: {label: 'ACT', value: 'act'},
                3: {label: 'VIC', value: 'vic'},
                4: {label: 'SA', value: 'sa'},
                5: {label: 'QLD', value: 'qld'},
                6: {label: 'NT', value: 'nt'},
                7: {label: 'WA', value: 'wa'},
                8: {label: 'TAS', value: 'ta'},
            }
        },
    ];

    const usersFilterOptions = [
        {
            field: "userId",
            label: "USER ID",
            icon: "fa-tag",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "fullName",
            label: "NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "entityTypeName",
            label: "ACCOUNT TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "Family", label: "Family" },
                2: { value: "Business", label: "Business" },
                3: { value: "Helper", label: "Helper" },
            }
        },
        {
            field: "membershipTypeName",
            label: "MEMBERSHIP TYPE",
            icon: "fa-bookmark",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "Free", label: "All" },
                // 2: { value: "PayAsYouGo", label: "Pay as you go" },
                3: { value: "Subscription", label: "Subscription" },
            }
        },
        {
            field: "accountStatusName",
            label: "ACCOUNT STATUS",
            icon: "fa-clock-o",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "Pending", label: "Pending" },
                2: { value: "Approved", label: "Approved" },
            }
        },
        {
            field: "email",
            label: "EMAIL",
            icon: "fa-at",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "phoneNumber",
            label: "PHONE NUMBER",
            icon: "fa-phone",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "hasProfileVideo",
            label: "HAS PROFILE VIDEO",
            icon: "fa-play",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "true", label: "Yes" },
                2: { value: "false", label: "No" },
            }
        },
        {
            field: "paymentInfo.payingMemberSince",
            label: "PAYING MEMBER SINCE",
            icon: "fa-calendar",
            isActive: false,
            value: 1,
            filterItemSelected: 1,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                // 1: { value: 1, label: "greater than", operator: "gt" },
                // 2: { value: 2, label: "less than", operator: "lt" },
                1: { value: 1, label: "has any value", operator: "isnotnull", hideValueField: true },
            }
        },
        {
            field: "isImageCropped",
            label: "HAS CROPPED PICTURE",
            icon: "fa-photo",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "true", label: "Yes" },
                2: { value: "false", label: "No" },
            }
        },
        {
            field: "isHidden",
            label: "ACCOUNT VISIBILITY",
            icon: "fa-eye",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "false", label: "Visible" },
                2: { value: "true", label: "Hidden" },
            }
        },
        {
            field: "addresses.formattedSuburb",
            label: "SUBURB",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "addresses.state",
            label: "REGION/CITY",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "addresses.state",
            label: "STATE",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'NSW', value: 'nsw'},
                2: {label: 'ACT', value: 'act'},
                3: {label: 'VIC', value: 'vic'},
                4: {label: 'SA', value: 'sa'},
                5: {label: 'QLD', value: 'qld'},
                6: {label: 'NT', value: 'nt'},
                7: {label: 'WA', value: 'wa'},
                8: {label: 'TAS', value: 'ta'},
            }
        },
        {
            field: "country",
            label: "COUNTRY",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'Australia', value: 'au'},
                2: {label: 'New Zealand', value: 'nz'},
            }
        },
        {
            field: "interestedInJobTypes",
            label: "JOB TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.jobType.BABYSITTING, label: "Babysitting" },
                3: { value: c.jobType.NANNYING, label: "Nannying (Daytime Care)" },
                4: { value: c.jobType.BEFORE_SCHOOL_CARE, label: "Before School Care" },
                5: { value: c.jobType.AFTER_SCHOOL_CARE, label: "After School Care" },
                6: { value: c.jobType.BEFORE_AFTER_SCHOOL_CARE, label: "Before and After School Care" },
                7: { value: c.jobType.AU_PAIR, label: "Au Pair" },
                8: { value: c.jobType.PRIMARY_SCHOOL_TUTORING, label: "Primary School Tutoring" },
                9: { value: c.jobType.HIGH_SCHOOL_TUTORING, label: "High School Tutoring" },
                10: { value: c.jobType.ONE_OFF_ODD_JOBS, label: "Odd Job" },
            }
        },
        {
            field: "clientInfo.jobsPlaced",
            label: "JOB POSTS",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "less than", operator: "lt" },
                3: { value: 3, label: "greater than", operator: "gt" },
            }
        },
        {
            field: "affiliateCode",
            label: "AFFILIATE CODE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
    ];

    const mediaFilterOptions = [
        {
            field: "fullName",
            label: "NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "mediaReviewStatus",
            label: "MEDIA REVIEW STATUS",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.mediaReviewStatuts.UNSPECIFIED, label: "Unspecified" },
                2: { value: c.mediaReviewStatuts.PENDING, label: "Pending" },
                3: { value: c.mediaReviewStatuts.APPROVED, label: "Approved" },
                4: { value: c.mediaReviewStatuts.REJECTED, label: "Rejected" },
            }
        },
    ]

    const surveyFilterOptions = [
        {
            field: "fullName",
            label: "NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "interestInHomeAgedCareResponse",
            label: "RESPONSES",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.surveyResponse.YES, label: "Yes" },
                2: { value: c.surveyResponse.NO, label: "No" },
                3: { value: c.surveyResponse.NA, label: "NA" },
            }
        },
        {
            field: "jugglerType",
            label: "ACCOUNT TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.jugglerType.PARENT, label: "Family" },
                2: { value: c.jugglerType.HELPER, label: "Helper" },
            }
        },
    ]

    const certificatesFilterOptions = [
        {
            field: "fullName",
            label: "NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "gender",
            label: "GENDER",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: 1, label: "Male" },
                2: { value: 2, label: "Female" },
                3: { value: 0, label: "Prefer not to say" },
            }
        },
        {
            field: "accountStatus",
            label: "ACCOUNT STATUS",
            icon: "fa-clock-o",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.accountStatus.PENDING, label: "Pending" },
                2: { value: c.accountStatus.APPROVED, label: "Approved" },
            }
        },
        {
            field: "addresses.state",
            label: "STATE",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'NSW', value: 'nsw'},
                2: {label: 'ACT', value: 'act'},
                3: {label: 'VIC', value: 'vic'},
                4: {label: 'SA', value: 'sa'},
                5: {label: 'QLD', value: 'qld'},
                6: {label: 'NT', value: 'nt'},
                7: {label: 'WA', value: 'wa'},
                8: {label: 'TAS', value: 'ta'},
            }
        },
        {
            field: "membershipType",
            label: "MEMBERSHIP TYPE",
            icon: "fa-bookmark",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.membershipType.free, label:"All" },
                // 2: { value: c.membershipType.payg, label: "PayAsYouGo"},
                3: { value: c.membershipType.subscription, label: "Subscription" },
            }
        },
        {
            field: "certificateStatus",
            label: "CERTIFICATE STATUS",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.certificateStatus.PENDINGVERIFICATION, label: "Pending Verification" },
                2: { value: c.certificateStatus.ACTIVE, label: "Active" },
                3: { value: c.certificateStatus.INVALID, label: "Invalid" },
                4: { value: c.certificateStatus.EXPIRED, label: "Expired" },
            }
        },
        {
            field: "isHidden",
            label: "ACCOUNT VISIBILITY",
            icon: "fa-eye",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "false", label: "Visible" },
                2: { value: "true", label: "Hidden" },
            }
        },
    ]

    const checksFilterOptions = [
        {
            field: "fullName",
            label: "NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "accountStatus",
            label: "ACCOUNT STATUS",
            icon: "fa-clock-o",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.accountStatus.PENDING, label: "Pending" },
                2: { value: c.accountStatus.APPROVED, label: "Approved" },
            }
        },
        {
            field: "country",
            label: "COUNTRY",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'Australia', value: 'au'},
                2: {label: 'New Zealand', value: 'nz'},
            }
        },
        {
            field: "membershipType",
            label: "MEMBERSHIP TYPE",
            icon: "fa-bookmark",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.membershipType.free, label:"All" },
                // 2: { value: c.membershipType.payg, label: "PayAsYouGo"},
                3: { value: c.membershipType.subscription, label: "Subscription" },
            }
        },
        {
            field: "visaCheckStatus",
            label: "CHECK STATUS",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.visaCheckStatus.PENDINGVERIFICATION, label: "Pending Verification" },
                2: { value: c.visaCheckStatus.APPROVED, label: "Approved" },
                3: { value: c.visaCheckStatus.INVALID, label: "Invalid" },
                4: { value: c.visaCheckStatus.EXPIRED, label: "Expired" },
            }
        },
        {
            field: "isHidden",
            label: "ACCOUNT VISIBILITY",
            icon: "fa-eye",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "false", label: "Visible" },
                2: { value: "true", label: "Hidden" },
            }
        },
    ]

    const jobsFilterOptions = [
         {
            field: "jobId",
            label: "JOB REFERENCE",
            icon: "fa-tag",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
            }
        },
        {
            field: "daysSincePost",
            label: "DAYS SINCE POST",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
            }
        },
        {
            field: "expiresInDays",
            label: "EXPIRES IN DAYS",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
            }
        },
        {
            field: "postDate",
            label: "JOB POST DATE",
            icon: "fa-calendar",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DATE_PICKER,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "before", operator: "lt" },
                3: { value: 3, label: "after", operator: "gt" },
            }
        },
        {
            field: "jobDate",
            label: "JOB START DATE",
            icon: "fa-calendar",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DATE_PICKER,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
            }
        },
        // {
        //     field: "jobFinishDate",
        //     label: "JOB FINISH DATE",
        //     icon: "fa-calendar",
        //     isActive: false,
        //     value: "",
        //     filterItemSelected: 0,
        //     filterType: filterType.DATE_PICKER,
        //     filterIitems: {
        //         1: { value: 1, label: "is", operator: "eq" },
        //     }
        // },
        {
            field: "userNumberOfJobPosts",
            label: "TOTAL JOB POSTS",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "less than", operator: "lt" },
                3: { value: 3, label: "greater than", operator: "gt" },
            }
        },
        {
            field: "userId",
            label: "USER ID",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
            }
        },
        {
            field: "jobType",
            label: "JOB TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.jobType.BABYSITTING, label: "Babysitting" },
                2: { value: c.jobType.RECURRING_JOB, label: "Recurring Jobs (All Types)" },
                3: { value: c.jobType.NANNYING, label: "Nannying (Daytime Care)" },
                4: { value: c.jobType.BEFORE_SCHOOL_CARE, label: "Before School Care" },
                5: { value: c.jobType.AFTER_SCHOOL_CARE, label: "After School Care" },
                6: { value: c.jobType.BEFORE_AFTER_SCHOOL_CARE, label: "Before and After School Care" },
                7: { value: c.jobType.AU_PAIR, label: "Au Pair" },
                8: { value: c.jobType.PRIMARY_SCHOOL_TUTORING, label: "Primary School Tutoring" },
                9: { value: c.jobType.HIGH_SCHOOL_TUTORING, label: "High School Tutoring" },
                10: { value: c.jobType.ONE_OFF_ODD_JOBS, label: "Odd Job" },
            }
        },
        {
            field: "jobStatus",
            label: "JOB STATUS",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.jobStatus.AWARDED, label: "Awarded" },
                2: { value: c.jobStatus.CANCELLED, label: "Cancelled" },
                3: { value: c.jobStatus.COMPLETED, label: "Completed" },
                4: { value: c.jobStatus.FILLED, label: "Filled" },
                5: { value: c.jobStatus.PENDING, label: "Pending" },
                6: { value: c.jobStatus.FILLED_AND_CANCELLED, label: "Filled and Closed" },
            }
        },
        {
            field: "managedBy",
            label: "Management",
            icon: "fa-gear",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.managedBy.USER, label: "Do It Yourself" },
                2: { value: c.managedBy.SYSTEM, label: "Juggle Assist" },
            }
        },
        {
            field: "country",
            label: "COUNTRY",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'Australia', value: 'au'},
                2: {label: 'New Zealand', value: 'nz'},
            }
        },
        {
            field: "addresses.state",
            label: "STATE",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'NSW', value: 'nsw'},
                2: {label: 'ACT', value: 'act'},
                3: {label: 'VIC', value: 'vic'},
                4: {label: 'SA', value: 'sa'},
                5: {label: 'QLD', value: 'qld'},
                6: {label: 'NT', value: 'nt'},
                7: {label: 'WA', value: 'wa'},
                8: {label: 'TAS', value: 'ta'},
            }
        },
    ]

    const jobRequestsFilterOptions = [
        {
            field: "",
            label: "REQUEST STATUS",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.jobRequestStatus.NEW_REQUEST, label: "New Request" },
                2: { value: c.jobRequestStatus.CALL_SCHEDULED, label: "Call Scheduled" },
                3: { value: c.jobRequestStatus.JOB_POSTED, label: "Job Posted" },
                4: { value: c.jobRequestStatus.JOB_TRANSFERRED, label: "Job Transferred" },
                5: { value: c.jobRequestStatus.JOB_AWARDED, label: "Job Awarded" },
            }
        },
    ]

    const affiliatesFilterOptions = [
        {
            field: "affiliateSource",
            label: "AFFILIATE SOURCE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'Referrals', value: 1 },
                2: {label: 'Employee Benefits', value: 2},
            }
        },
        {
            field: "affiliateStatus",
            label: "AFFILIATE STATUS",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'All', value: 0 },
                2: {label: 'Used', value: 1},
                3: {label: 'Activated', value: 2},
            }
        },
        {
            field: "affiliateName",
            label: "PARTNER NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "code",
            label: "PARTNER CODE",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
    ]

    const vouchesFilterOptions = [
        {
            field: "userId",
            label: "USER ID",
            icon: "fa-tag",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
            }
        },
        {
            field: "fullName",
            label: "USER NAME",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "status",
            label: "STATUS",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.vouchStatus.PENDING, label: "Follow-up" },
                2: { value: c.vouchStatus.APPROVED, label: "Complete" },
                3: { value: c.vouchStatus.CANCELLED, label: "Incomplete" },
                4: { value: c.vouchStatus.EXPIRED, label: "Expired" },
                // 5: { value: c.vouchStatus.NONE, label: "-" },
            }
        },
        {
            field: "accountStatus",
            label: "ACCOUNT STATUS",
            icon: "fa-clock-o",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: c.accountStatus.PENDING, label: "Pending" },
                2: { value: c.accountStatus.PENDING_APPROVAL, label: "Pending 100%" },
                3: { value: c.accountStatus.APPROVED, label: "Approved" },
            }
        },
        {
            field: "isHidden",
            label: "VISIBILITY",
            icon: "fa-eye",
            isActive: false,
            value: "",
            filterItemSelected: 1,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "false", label: "Visible" },
                2: { value: "true", label: "Hidden" },
            }
        },
        {
            field: "interestedInAuPairJobs",
            label: "IS AU PAIR",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "true", label: "Yes" },
                2: { value: "false", label: "No" },
            }
        },
        {
            field: "referenceType",
            label: "REF TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                // 1: { value: c.vouchReferenceType.FAMILY, label: "Family" },
                // 2: { value: c.vouchReferenceType.CHILDCAREEMPLOYMENT, label: "Childcare Employment" },
                // 3: { value: c.vouchReferenceType.NONCHILDCAREEMPLOYMENT, label: "Non-childcare Employment" },
                // 4: { value: c.vouchReferenceType.OTHER, label: "Other" },
                1: { value: c.vouchReferenceType.REFERENCES, label: "References" },
                2: { value: c.vouchReferenceType.JUGGLESTREET, label: "Juggle Street" },
            }
        },
        {
            field: "state",
            label: "REGION/CITY",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "state",
            label: "STATE",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'NSW', value: 'nsw'},
                2: {label: 'ACT', value: 'act'},
                3: {label: 'VIC', value: 'vic'},
                4: {label: 'SA', value: 'sa'},
                5: {label: 'QLD', value: 'qld'},
                6: {label: 'NT', value: 'nt'},
                7: {label: 'WA', value: 'wa'},
                8: {label: 'TAS', value: 'ta'},
            }
        },
        {
            field: "country",
            label: "COUNTRY",
            icon: "fa-map-marker",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: {label: 'Australia', value: 'au'},
                2: {label: 'New Zealand', value: 'nz'},
            }
        },
    ]

    const botManagerFilterOptions = [
        {
            field: "flowType",
            label: "FLOW TYPE",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "contains", operator: "contains" },
            }
        }
    ]

    const botSessionsFilterOptions = [
        {
            field: "userName",
            label: "User Name",
            icon: "fa-user",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.FREE_TEXT,
            filterIitems: {
                1: { value: 1, label: "is", operator: "eq" },
                2: { value: 2, label: "contains", operator: "contains" },
            }
        },
        {
            field: "channelId",
            label: "Channel",
            icon: "fa-ticket",
            isActive: false,
            value: "",
            filterItemSelected: 0,
            filterType: filterType.DROP_DOWN,
            filterIitems: {
                1: { value: "facebook", label: "Facebook" },
                2: { value: "emulator", label: "Emulator" }
            }
        }
    ]

    return {
        filterType,
        usersFilterOptions,
        profilesFilterOptions,
        mediaFilterOptions,
        surveyFilterOptions,
        certificatesFilterOptions,
        checksFilterOptions,
        jobsFilterOptions,
        jobRequestsFilterOptions,
        affiliatesFilterOptions,
        vouchesFilterOptions,
        botManagerFilterOptions,
        botSessionsFilterOptions,
        businessesFilterOptions,
        globalUsersFilterOptions,
        globalProfilesFilterOptions,
        globalJobsFilterOptions,
        globalAffiliatesFilterOptions,
        globalVouchesFilterOptions,
        globalCertificatesFilterOptions,
        globalChecksFilterOptions,
        globalBotManagerFilterOptions,
        globalBotSessionsFilterOptions,
        globalBusinessesFilterOptions,
        globalJobRequestsFilterOptions,
    }

})()

export default FilterHelper;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/utils/filter-helper.js
 **/